import { Loader2 } from "lucide-react"

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="w-16 h-16 border-4 border-solid border-primary border-t-transparent rounded-full animate-spin"></div>
    </div>
  )
}

export default LoadingSpinner

/**
 * This component is the loading spinner with the shadow screen
 */
export const LoadingOverlay = () => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <LoadingSpinner />
    </div>
  )
}

interface Props {
  progress: number;
  showProgress?: boolean;
}

export const ProgressOverlay: React.FC<Props> = ({ progress, showProgress = true }) => {
  return (
    <div className="absolute inset-0 z-50 bg-white/70 backdrop-blur-sm flex flex-col items-center justify-center">
      <Loader2 className="animate-spin text-primary mb-4" size={32} />
      <div className="text-sm font-semibold text-gray-800">Caricamento documento...</div>
      {showProgress && (
        <>
          <div className="w-3/4 h-2 mt-3 bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-full bg-primary transition-all duration-200 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="text-xs text-gray-500 mt-1">{Math.round(progress)}%</div>
        </>
      )}
    </div>
  );
};
